
import { FaHome ,FaHeart } from "react-icons/fa";
import {
  MdPerson,
  MdShoppingBag,
  MdOutlinePersonOutline
} from "react-icons/md";
import { SlLocationPin } from "react-icons/sl";
import { FiLayers } from "react-icons/fi";
import { PiSignOutBold } from "react-icons/pi";
import { BiSolidOffer } from "react-icons/bi";


export const menuByUserType = {
  "delivery user": [
    { label: "Profile", route: "/delivery/profile", icon: <MdPerson size={18} /> },
  ],
  "business user": [
    { label: "Profile", route: "/app/business/profile", icon: <MdPerson size={18} /> },
  ],
  "employee user": [
    { label: "Profile", route: "/app/business/profile", icon: <MdPerson size={18} /> },
  ],
  "admin": [
    { label: "Profile", route: "/app/profile", icon: <MdPerson size={18} /> },
  ],
  "normal user": [
    { label: "Home ", route: "/customer-home", icon: <FaHome  size={18} /> },
    { label: "Profile", route: "/profile", icon: <MdPerson size={18} /> },
    { label: "My Orders", route: "/my-orders", icon: <MdShoppingBag size={18} /> },
    { label: "favourite", route: "/favourite", icon: <FaHeart size={18} /> },
    { label: "Addresses", route: "/addresses", icon: <SlLocationPin size={18} /> },
    { label: "Offered Laundry", route: "/offered-laundry", icon: <BiSolidOffer size={18} /> },
  ]
};

export const navItems = [
  {
    label: "Profile Information",
    icon: <MdOutlinePersonOutline />,
    to: "/profile",
  },
  {
    label: "Manage Addresses",
    icon: <SlLocationPin />,
    to: "/addresses",
  },
  {
    label: "My Orders",
    icon: <FiLayers />,
    to: "/my-orders",
  },
  {
    label: "Favourite",
    icon: <FaHeart />,
    to: "/favourite",
  },
   {
    label: "Offered Laundry",
    icon: <BiSolidOffer />,
    to: "/offered-laundry",
  },
  {
    label: "Logout",
    icon: <PiSignOutBold />,
    to: "/",
  },
];